import PropTypes from 'prop-types';
import { Button } from '@bwoty-web/ui-kit';
import Heading from '../geoInformation/heading/Heading';
import Description from '../../common/description';
import { isRegion } from '../../utils/geoTypeUtils';

import '../geoInformation/geoInformation.scss';

const HotelFinderPreambleView = ({ hotelInformation, itemType }) => {
  const heading = (
    <Heading
      destinationName={hotelInformation.name}
      geographical={hotelInformation.geographical}
      titlePrefix={hotelInformation.labels.titlePrefix}
      hideSubtitle={isRegion(itemType)}
    />
  );

  return (
    <div className="gw-information-container uikit-box">
      <div className="gw-information">
        <div className="gw-information__left">
          {heading}
          <Description
            paragraphs={hotelInformation.hotelListTexts}
            showMoreText={hotelInformation.labels.showMoreText}
            hideText={hotelInformation.labels.hideText}
            geoType={itemType}
            mobileHeading={heading}
          />
          <div className="gw-information__buttons">
            <Button
              className="gw-information__right-items-link"
              href={hotelInformation.url}
            >
              {hotelInformation.labels.destinationLinkText}
            </Button>
          </div>
        </div>
        <div className="gw-information__right" />        
      </div>
    </div>
  );
};

HotelFinderPreambleView.propTypes = {
  hotelInformation: PropTypes.shape({
    name: PropTypes.string.isRequired,
    url: PropTypes.string,
    geographical: PropTypes.shape({
      country: PropTypes.shape({}).isRequired,
      area: PropTypes.shape({}),
    }).isRequired,
    hotelListTexts: PropTypes.arrayOf(
      PropTypes.shape({
        content: PropTypes.string,
      }),
    ),
    labels: PropTypes.shape({
      titlePrefix: PropTypes.string.isRequired,
      showMoreText: PropTypes.string.isRequired,
      hideText: PropTypes.string.isRequired,
      destinationLinkText: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  itemType: PropTypes.string.isRequired,
};

export default HotelFinderPreambleView;
